import { FormattedMessage } from 'dibs-react-intl';

export const frequentlyAskedQuestions = header => (
    <FormattedMessage
        id="buy.frequentlyAskedQuestions"
        defaultMessage="Questions About {header}"
        values={{ header }}
    />
);

export const noInventoryAvailable = (
    <FormattedMessage
        id="buy.noInventoryAvailable"
        defaultMessage="No exact matches, view similar items and recent sales below"
    />
);
